module.exports = __webpack_public_path__ + "img/067.ffd3d94a.png";